import type { IRowNode, ValueGetterParams } from "ag-grid-community";

import { VisualizationItemType } from "~/shared/enums";
import type { VisualizationItem } from "~/shared/types";

// This is used to reload the grid row when it changes
export const listValueGetter = <T extends VisualizationItem>(params: ValueGetterParams<T>): boolean =>
  params.data?.itemType === VisualizationItemType.TASK && !!params.data?.absentee;

export const getRowId = (params: IRowNode<VisualizationItem>) => {
  if (params.data?.itemType === VisualizationItemType.TASK) {
    return params.data.duid;
  }
  if (params.data?.itemType === VisualizationItemType.CREATE_MODAL) {
    return "CREATE_MODAL";
  }
  return params.data?.key;
};
